import Snackbar from './Snackbar.vue'

function Install (Vue, options) {
  const property = (options && options.property) || '$snackbar'
  function createDialogCmp (options) {
    return new Promise(resolve => {
      const cmp = new Vue(Object.assign(Snackbar, {
        destroyed: (c) => {
        }
      }))
      Object.assign(cmp, Vue.prototype[property].options || {}, options)
      document.body.appendChild(cmp.$mount().$el)
    })
  }

  function show (message, options = {}) {
    options.message = message
    if (options.timeout == null) {
      options.timeout = Math.max(15, Math.ceil(options.message.length / 5) * 1000)// 5个字1秒
    }
    return createDialogCmp(options)
  }

  Vue.prototype[property] = show
  Vue.prototype[property].options = options || {}

  Vue.prototype.$toast = show
}

export default Install
